var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("common.backupRestore"),
        width: "40%",
        visible: _vm.backupVisible,
        "close-on-click-modal": false,
        modal: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.backupVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          staticStyle: { width: "100%", "font-size": "16px" },
          attrs: {
            data: _vm.tableData,
            height: "330px",
            "show-header": _vm.showHeader,
            size: "mini",
            "element-tableLoading-text": _vm.$t("action.loading"),
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "title",
              label: _vm.$t("common.versionName"),
              "header-align": "center",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("action.operation"),
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRestore(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.restore")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          disabled: scope.row.name == "backup" ? true : false,
                          size: "mini",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.delete")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.backupVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleBackup },
            },
            [_vm._v(_vm._s(_vm.$t("common.backup")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }